import { EventViewData } from 'components/eventView/pages/eventData';

// Exhibitors   b652baa9-4cac-4f50-83f3-06bbc5d00586
// Speakers     a55033b6-99fe-49ad-a8f1-2b26a6ba257c
// Awards       9f3f5170-7d96-4189-afe3-10a5f81a4e28

export const MarenaEvent: EventViewData = {
    eventId: 'marena',
    mapId: 'f6a44886-4a0f-4809-ab66-48340962e528',
    guideId: 'cd1beb73-fff4-4f4f-9a3b-d1d6ec30c30b',
    eventInfo: {
        order: {
            mobile: [
                'home',
                'b652baa9-4cac-4f50-83f3-06bbc5d00586',
                'map',
                'program',
                'information'
            ],
            wide: [
                'home',
                'b652baa9-4cac-4f50-83f3-06bbc5d00586',
                'program',
                'a55033b6-99fe-49ad-a8f1-2b26a6ba257c',
                '9f3f5170-7d96-4189-afe3-10a5f81a4e28',
                '...',
                'information',
                'map'
            ],
            primes: ['b652baa9-4cac-4f50-83f3-06bbc5d00586'],
            normal: [
                'program',
                'a55033b6-99fe-49ad-a8f1-2b26a6ba257c',
                '9f3f5170-7d96-4189-afe3-10a5f81a4e28',
                '...',
                'information'
            ]
        }
    }
};
